<template>
  <Command v-if="toValue(navigator)?.tableOfContents?.length" @click="trigger">
    <slot
      v-bind="{
        disabled: false,
        icon: 'toc',
        label: t('moreOptions.toc'),
        toolTip: t('moreOptions.toc'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { toValue } from "vue";
import { useI18n } from "vue-i18n";

import TableOfContents from "@/components/reader/TableOfContents.vue";
import { TransitionType, useUILayers } from "@/components/UILayers";
import { posthogKeys } from "@/helpers/constants";
import { usePostHog } from "@/helpers/posthog";
import { useNavigator } from "@/components/navigator";

import Command from "../command";

const navigator = useNavigator();

const { capture: capturePosthogEvent } = usePostHog();

const { t } = useI18n();

const { add } = useUILayers();

function trigger() {
  add(
    TableOfContents,
    {},
    {
      transition: TransitionType.SlideSidebarLeft,
    }
  );
  capturePosthogEvent(posthogKeys.toc);
}
</script>
